import { render, staticRenderFns } from "./CustomerRideHistoryViewTable.vue?vue&type=template&id=6cbbda15&scoped=true&lang=pug&"
import script from "./CustomerRideHistoryViewTable.vue?vue&type=script&lang=js&"
export * from "./CustomerRideHistoryViewTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRideHistoryViewTable.vue?vue&type=style&index=0&id=6cbbda15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbbda15",
  null
  
)

export default component.exports